import { SettingsManager as BaseSettingsManager } from '@bn-games/settings-core';
import { DEFAULT_SETTINGS, type Settings } from './types.js';

const STORAGE_KEY = 'checkers-settings';

function merge(stored: Record<string, unknown>, defaults: Settings): Settings {
  return {
    sound:
      typeof stored['sound'] === 'boolean' ? stored['sound'] : defaults.sound,
    difficulty:
      stored['difficulty'] === 'easy' ||
      stored['difficulty'] === 'normal' ||
      stored['difficulty'] === 'hard' ||
      stored['difficulty'] === 'expert'
        ? stored['difficulty']
        : defaults.difficulty,
    defaultColor:
      stored['defaultColor'] === 'white' || stored['defaultColor'] === 'black' || stored['defaultColor'] === 'random'
        ? stored['defaultColor']
        : defaults.defaultColor,
    theme:
      stored['theme'] === 'mahogany' ||
      stored['theme'] === 'persian' ||
      stored['theme'] === 'deco' ||
      stored['theme'] === 'monte'
        ? stored['theme']
        : defaults.theme,
    language:
      stored['language'] === 'en' || stored['language'] === 'ru'
        ? stored['language']
        : defaults.language,
    showValidMoves:
      typeof stored['showValidMoves'] === 'boolean'
        ? stored['showValidMoves']
        : defaults.showValidMoves,
    playerName:
      typeof stored['playerName'] === 'string' &&
      (stored['playerName'] as string).trim().length > 0
        ? (stored['playerName'] as string).trim()
        : defaults.playerName,
    variant:
      stored['variant'] === 'russian' || stored['variant'] === 'english'
        ? stored['variant']
        : defaults.variant,
    afkAssistEnabled:
      typeof stored['afkAssistEnabled'] === 'boolean'
        ? stored['afkAssistEnabled']
        : defaults.afkAssistEnabled,
    afkTimeoutMs:
      typeof stored['afkTimeoutMs'] === 'number' && Number.isFinite(stored['afkTimeoutMs'])
        ? (stored['afkTimeoutMs'] as number)
        : defaults.afkTimeoutMs,
    afkRemindersEnabled:
      typeof stored['afkRemindersEnabled'] === 'boolean'
        ? stored['afkRemindersEnabled']
        : defaults.afkRemindersEnabled,
    turnStartSound:
      typeof stored['turnStartSound'] === 'boolean'
        ? stored['turnStartSound']
        : defaults.turnStartSound,
    showAfkPingButton:
      typeof stored['showAfkPingButton'] === 'boolean'
        ? stored['showAfkPingButton']
        : defaults.showAfkPingButton,
  };
}

export class SettingsManager extends BaseSettingsManager<Settings> {
  constructor() {
    super(STORAGE_KEY, DEFAULT_SETTINGS, merge);
  }
}
